import { createContext } from 'react';

export const ParamConfigContext = createContext();
